import { forwardRef } from 'react';

import { Link, type LinkProps } from '@/components/Link';
import { SURVEY_PATH } from '@/features/survey';

export const LinkSurvey = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to: _to, ...rest }, ref) => {
    const to = `${SURVEY_PATH}${_to}`;
    return <Link ref={ref} to={to} {...rest} />;
  }
);

LinkSurvey.displayName = 'LinkSurvey';
``;
